import React from 'react'

import { CloseCircleFilled } from '@ant-design/icons'

import Modal, { ModalFuncProps } from 'antd/es/modal'

// TODO: Replace className with theme
export const showErrorModal = ({ icon, ...rest }: ModalFuncProps) => {
  Modal.error({
    className: 'ant-dialog-modal-v5',
    width: 350,
    title: 'Error',
    icon: icon || <CloseCircleFilled className="modal-warning-icon" />,
    ...rest
  })
}
